import { Typography } from '@mui/material'
import BoxWithBackground from 'components/atoms/container/BoxWithBackground'
import { useTranslation } from 'react-i18next'
import { ColStack } from 'components/atoms/container/InCardStack'
import PathCard from 'components/molecules/home/PathCard'
import colors from 'styles/colors'
import RowStack from 'components/atoms/container/RowStack'
import moment from 'moment'

const MyPathArea = ({ goals }) => {
  const { t } = useTranslation()
  const activeGoals = goals.filter(goal => goal.active)
  const completedGoals = goals.filter(goal => goal.progress?.completed)
  const openSoonGoals = goals
    .filter(goal => goal.opensAt)
    .sort((a, b) => {
      if (!a.opensAt) return 1
      if (!b.opensAt) return -1
      return moment(a.opensAt).valueOf() - moment(b.opensAt).valueOf()
    })

  const SectionWrapper = ({ children, heading, backgroundColor }) => (
    <BoxWithBackground
      backgroundColor={backgroundColor}
      borderRadius={3}
      padding={6}>
      <ColStack spacing={2}>
        <Typography variant='eyebrow'>{heading}</Typography>

        <RowStack spacing={0} gap={8} flexWrap={'wrap'}>
          {children}
        </RowStack>
      </ColStack>
    </BoxWithBackground>
  )

  const SectionCard = ({ goal }) => (
    <PathCard goal={goal} isLibrary={false} sx={{ width: 326 }} />
  )

  return (
    <ColStack spacing={16}>
      <ColStack spacing={8}>
        <Typography variant='h2'>{t('home.myPaths')}</Typography>
        {openSoonGoals.length === 0 && activeGoals.length === 0 && (
          <BoxWithBackground padding={8} width='100%'>
            <Typography>{t('home.noCurrentUpcomingPaths')}</Typography>
          </BoxWithBackground>
        )}
        <RowStack spacing={8} alignItems={'flex-start'}>
          {openSoonGoals.length > 0 && (
            <SectionWrapper
              heading={t('home.opensSoon')}
              backgroundColor={colors.MutedTeal50}>
              <SectionCard goal={openSoonGoals[0]} />
            </SectionWrapper>
          )}

          {activeGoals.length > 0 && (
            <SectionWrapper
              heading={t('overview.active')}
              backgroundColor={colors.GoldenYellow50}>
              {activeGoals.map(goal => (
                <SectionCard key={`goal-${goal.id}`} goal={goal} />
              ))}
            </SectionWrapper>
          )}
        </RowStack>
      </ColStack>

      {completedGoals.length > 0 && (
        <SectionWrapper
          heading={t('common.completed')}
          backgroundColor={colors.MetalGrey50}>
          {completedGoals.map(goal => (
            <SectionCard key={`goal-${goal.id}`} goal={goal} />
          ))}
        </SectionWrapper>
      )}
    </ColStack>
  )
}

export default MyPathArea
